/**
 * useBranding - reads branding from the manifest and applies CSS variables.
 *
 * On mount (and when branding changes), overrides design-token CSS custom
 * properties on :root so the entire app reflects the org's brand colors.
 */
import { useEffect } from "react";

import { useManifest } from "@/features/manifest/model/useManifest";

import { applyBrandingCss } from "./brandingCss";

const DEFAULT_PRIMARY = "#0F766E";
const DEFAULT_SECONDARY = "#115E59";

/** Hook: apply org branding CSS vars and expose branding values for UI. */
export function useBranding() {
  const { manifest } = useManifest();
  const branding = manifest?.branding;

  useEffect(() => {
    applyBrandingCss(branding);
  }, [branding]);

  return {
    logoUrl: branding?.logo_url || null,
    dashboardName: branding?.dashboard_name || null,
    primaryColor: branding?.primary_color || DEFAULT_PRIMARY,
    secondaryColor: branding?.secondary_color || DEFAULT_SECONDARY,
    sidebarBg: branding?.sidebar_bg || "",
    sidebarText: branding?.sidebar_text || "",
  };
}
